import React from "react";
import "./Contact.css";
import { MdOutlineEmail } from "react-icons/md";
import { useForm, ValidationError } from "@formspree/react";
import { AiFillLinkedin } from "react-icons/ai";

const Contact = () => {
  const [state, handleSubmit] = useForm("mgvwklyy");

  if (state.succeeded) {
    return <p>Дякую за відповідь!</p>;
  }

  return (
    <section id="contact">
      <div className="section__wrapper contact__container">
        <div className="section__header">
          <h2 className="primary__title">Зв'яжіться зі мною</h2>
          <p className="text__muted description">
            Я завжди відкрита до нових ідей та співпраці. Якщо у вас є проєкт
            або питання, не соромтеся звертатися!
          </p>
        </div>
        <div className="contact__group">
          <div className="contact__options">
            <article className="contact__option">
              <MdOutlineEmail className="contact__icon" />
              <h3>Gmail</h3>
              <a
                href="mailto:emiliiagrab@gmail.com"
                target="__blank"
                rel="noopener noreferrer"
                className="btn"
              >
                Написати
              </a>
              
            </article>
            <article className="contact__option">
              <AiFillLinkedin className="contact__icon" />
              <h3>LinkedIn</h3>
              <a
                href="https://www.linkedin.com/in/emilia-grab/"
                target="__blank"
                rel="noopener noreferrer"
                className="btn"
              >
                Написати
              </a>
            </article>
            {/* <article className="contact__option">
              <FaTelegramPlane className="contact__icon" />
              <h3>Telegram</h3>
              <a
                href="https://t.me/millunchik"
                target="__blank"
                rel="noopener noreferrer"
                className="btn"
              >
                Написати
              </a>
            </article> */}
          </div>

          <form onSubmit={handleSubmit}>
            <label htmlFor="name">Ім'я</label>
            <input
              id="name"
              type="text"
              name="name"
              placeholder="Ваше ім'я"
              required
            />
            <ValidationError prefix="Name" field="name" errors={state.errors} />

            <label htmlFor="email">Електронна адреса</label>
            <input
              id="email"
              type="email"
              name="email"
              placeholder="Ваша електронна адреса"
              required
            />
            <ValidationError
              prefix="Email"
              field="email"
              errors={state.errors}
            />

            <label htmlFor="message">Повідомлення</label>
            <textarea
              id="message"
              name="message"
              rows={7}
              placeholder="Ваше повідомлення"
              required
            ></textarea>
            <ValidationError
              prefix="Message"
              field="message"
              errors={state.errors}
            />

            <button
              type="submit"
              disabled={state.submitting}
              className="btn btn__primary"
            >
              Надіслати повідомлення
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
